import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Cookies from "universal-cookie";
import { Logger } from "../../Logger/Logger";
const ProtectedRoutes = (props) => {
  const cookies = new Cookies();
  const { Component } = props;
  const navigate = useNavigate();
  const userLoginId = cookies.get("UserLoginAccessToken");
  Logger.debug("userlogin id", userLoginId);
  Logger.info("userlogin id", userLoginId);

  useEffect(() => {
    if (!userLoginId) {
      navigate("/");
    }
  }, []);
  return (
    <>
      <Component />
    </>
  );
};

export default ProtectedRoutes;
